/* Бляк — scroll motion (no dependencies, ~2 KB)
   - reveals: one IntersectionObserver, each element animates once
   - elements entering together are staggered; "groups" reveal as one unit
   - parallax: desktop only, rAF-throttled, only while visible */
(function () {
  var root = document.documentElement;
  window.__bkMotion = true;
  if (!root.classList.contains('bk-motion')) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var desktop = window.matchMedia('(min-width: 990px)');

  /* signature moments + the "landmarks" (headings, photos, review cards);
     body text, lists, steps, FAQ and the buy box are simply there */
  var ITEMS = [
    '.bk-flip', '.bk-how__t1', '.bk-how__t2', '.bk-how__t3', '.bk-bubble',
    '.bk-sec .bk-head > *', '.bk-gallery figure', '.bk-box__img', '.bk-how__img', '.bk-buy__img', '.bk-review'
  ].join(',');

  /* containers whose items reveal together (watched as a whole), rhythm in ms */
  var GROUPS = [
    { sel: '.bk-head', step: 80 },
    { sel: '.bk-cards', step: 110, start: 120 },
    { sel: '.bk-how__visual', delays: { 'bk-how__img': 0, 'bk-how__t1': 300, 'bk-how__t2': 410, 'bk-how__t3': 520 } },
    { sel: '.bk-qr', bubble: 250 }
  ];

  var BATCH_STEP = 90, BATCH_MAX = 3;
  /* phones: same feel, a slightly tighter rhythm */
  function tempo(ms) { return desktop.matches ? ms : Math.round(ms * 0.75); }

  function reveal(el, delay) {
    if (el.classList.contains('is-in')) return;
    el.style.setProperty('--bk-d', tempo(delay || 0) + 'ms');
    el.classList.add('is-in');
    el.addEventListener('animationend', function done(e) {
      /* opacity finishes first; wait for the movement to end */
      if (e.target !== el || e.animationName === 'bk-o') return;
      el.classList.add('is-done');
      el.removeEventListener('animationend', done);
    });
  }

  function showNow(el) {
    var grp = groupOf(el);
    var list = grp ? [grp.box].concat(Array.prototype.slice.call(grp.box.querySelectorAll(ITEMS))) : [el];
    if (grp) grp.box.__bkIn = true;
    list.forEach(function (k) { if (k.matches(ITEMS)) k.classList.add('is-in', 'is-done'); });
  }

  function revealGroup(g, box) {
    var kids = Array.prototype.filter.call(box.querySelectorAll(ITEMS), function (k) { return k.closest(g.sel) === box; });
    if (box.matches(ITEMS)) kids.unshift(box);
    var n = 0;
    kids.forEach(function (k) {
      var d;
      if (g.delays) {
        for (var c in g.delays) if (k.classList.contains(c)) d = g.delays[c];
      }
      if (d === undefined && g.bubble && k.classList.contains('bk-bubble')) d = g.bubble;
      if (d === undefined) d = (g.start || 0) + n++ * (g.step || 80);
      reveal(k, Math.min(d, 700));
    });
    if (box.classList.contains('bk-cards')) peek(box);
  }

  /* one-time hint that the cards can be flipped */
  var peeked = false;
  function peek(box) {
    if (peeked) return;
    peeked = true;
    var touched = false;
    box.addEventListener('pointerenter', function () { touched = true; }, { once: true });
    box.addEventListener('touchstart', function () { touched = true; }, { once: true, passive: true });
    var cards = box.querySelectorAll('.bk-flip');
    var card = cards[desktop.matches ? 1 : 0];
    if (!card) return;
    setTimeout(function () {
      if (touched || card.classList.contains('is-flipped')) return;
      var inner = card.querySelector('.bk-flip__in');
      if (!inner) return;
      inner.classList.add('bk-peek');
      inner.addEventListener('animationend', function () { inner.classList.remove('bk-peek'); }, { once: true });
    }, 1500);
  }

  function groupOf(el) {
    for (var i = 0; i < GROUPS.length; i++) {
      var box = el.closest(GROUPS[i].sel);
      if (box) return { g: GROUPS[i], box: box };
    }
    return null;
  }

  function init(scope) {
    var els = scope.querySelectorAll(ITEMS);
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in', 'is-done'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      var batch = [];
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        if (past) past.unobserve(e.target);
        batch.push(e.target);
      });
      batch.sort(function (a, b) { return a.compareDocumentPosition(b) & 2 ? 1 : -1; });
      var k = 0;
      batch.forEach(function (el) {
        var grp = groupOf(el);
        if (grp) {
          if (!grp.box.__bkIn) { grp.box.__bkIn = true; revealGroup(grp.g, grp.box); }
          return;
        }
        reveal(el, Math.min(k++, BATCH_MAX) * BATCH_STEP);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });

    /* anything that ends up above the viewport without ever being seen
       (anchor jumps, restored scroll) is shown instantly */
    var past = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && e.boundingClientRect.bottom < 0) {
          past.unobserve(e.target); io.unobserve(e.target); showNow(e.target);
        }
      });
    }, { rootMargin: '100000px 0px -100% 0px', threshold: 0 });

    els.forEach(function (el) {
      var grp = groupOf(el);
      /* groups are watched through their container, so a horizontally
         scrolled card row on mobile still reveals as one */
      if (grp) {
        if (!grp.box.__bkWatch) { grp.box.__bkWatch = true; io.observe(grp.box); past.observe(grp.box); }
      } else {
        io.observe(el); past.observe(el);
      }
    });
  }

  /* ---------- sticky header shadow + parallax ---------- */
  var nav = document.querySelector('.bk-nav');
  var layers = [];
  function collectLayers() {
    layers = [];
    [['.bk-hero__blobs .b1', 0.1], ['.bk-hero__blobs .b2', -0.06], ['.bk-hero__blobs .b3', 0.14],
     ['.bk-how__t1', -0.09], ['.bk-how__t2', 0.07], ['.bk-how__t3', -0.05]].forEach(function (p) {
      document.querySelectorAll(p[0]).forEach(function (el) { layers.push({ el: el, f: p[1], sec: el.closest('section') }); });
    });
  }

  var ticking = false;
  function frame() {
    ticking = false;
    var y = window.scrollY;
    if (nav) nav.classList.toggle('is-scrolled', y > 8);
    if (reduce.matches || !desktop.matches) return;
    var vh = window.innerHeight;
    for (var i = 0; i < layers.length; i++) {
      var L = layers[i];
      var r = (L.sec || L.el).getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) continue;
      /* distance of the section centre from the viewport centre */
      var off = (r.top + r.height / 2) - vh / 2;
      var v = Math.max(-40, Math.min(40, off * L.f));
      L.el.style.setProperty('--bk-py', v.toFixed(1) + 'px');
    }
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }

  function resetLayers() {
    if (desktop.matches && !reduce.matches) return onScroll();
    layers.forEach(function (L) { L.el.style.removeProperty('--bk-py'); });
  }

  function start() {
    init(document);
    collectLayers();
    frame();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    if (desktop.addEventListener) desktop.addEventListener('change', resetLayers);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
